import React from 'react';
import ActionsMenu, {
    ActionsMenuProps,
} from '../../common/Navigation/ActionsMenu';
import OperationalReportDeleteButton from './OperationalReportDeleteButton';
import OperationalReportViewButton from './OperationalReportViewButton';
import CcReport from '../../services/models/CcReport';
import { DeleteOutlined, FileTextOutlined } from '@ant-design/icons';

export default OperationalReportActionMenu;

export type OperationalReportActionMenuProps = ActionsMenuProps & {
    report: CcReport;
    onActionPerformed?: Function;
};

function OperationalReportActionMenu({
    report,
    onActionPerformed,
}: OperationalReportActionMenuProps) {
    return (
        <ActionsMenu
            items={[
                {
                    key: 'view',
                    icon: <FileTextOutlined />,
                    label: <OperationalReportViewButton report={report} />,
                },
                {
                    key: 'delete',
                    waitForConfirm: true,
                    critical: true,
                    icon: <DeleteOutlined />,
                    label: (
                        <OperationalReportDeleteButton
                            report={report}
                            onSuccess={onActionPerformed}
                        />
                    ),
                },
            ]}
        />
    );
}
